import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import ROUTES from 'config/routes.json'
import content from 'prismic-translates/favorites-page.json'
import ButtonLink from 'src/components/ButtonLink'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export default function NoFavoritesGames() {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <h6 className={classes.title} data-test={'no-favorites-header'}>
          {t('add_game_to_favorites')}
        </h6>

        <ButtonLink
          variant='contained'
          className={classes.btnLink}
          href={ROUTES.HOME}
          data-test={'no-favorites-button'}
        >
          {t('go_to_home_page')}
        </ButtonLink>
      </div>
    </div>
  )
}
